/* Read-only geometry observation. Only read the exported activator part for geometry; never change provider internals or commerce events. */
if (!customElements.get('rp-v2-floating-ui')) {
  customElements.define('rp-v2-floating-ui', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.frame = 0;
      this.observed = new Set();
      this.queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {this.frame=0;this.update();});
      };
      this.resize = new ResizeObserver(this.queue);
      this.mutations = new MutationObserver(this.queue);
      this.mutations.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden']});
      window.addEventListener('scroll',this.queue,{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',this.queue,{passive:true,signal:this.abort.signal});
      document.addEventListener('transitionend',event=>{
        if(event.target instanceof Element && event.target.closest('sticky-cart,shopify-chat')) this.queue();
      },{capture:true,signal:this.abort.signal});
      window.visualViewport?.addEventListener('resize',this.queue,{signal:this.abort.signal});
      this.queue();
    }
    visible(element) {
      const rect=element.getBoundingClientRect(), css=getComputedStyle(element);
      return rect.width>0 && rect.height>0 && rect.bottom>0 && rect.top<innerHeight && css.display!=='none' && css.visibility!=='hidden' && Number(css.opacity)>0;
    }
    update() {
      const host=document.querySelector('shopify-chat');
      if (!host) return;
      this.host=host;
      let bottom=16;
      document.querySelectorAll('sticky-cart').forEach(element=>{
        if(!this.observed.has(element)){this.resize.observe(element);this.observed.add(element);}
        if(element.classList.contains('open') && this.visible(element)) bottom=Math.max(bottom,innerHeight-element.getBoundingClientRect().top+16);
      });
      // Keep the Inbox launcher above visible V2 purchase controls, including Shop Pay.
      document.querySelectorAll('.rp-v2-pdp-purchase .product-form__buttons').forEach(element=>{
        if(!this.observed.has(element)){this.resize.observe(element);this.observed.add(element);}
        if(!this.visible(element)) return;
        const rect=element.getBoundingClientRect();
        const launcherTop=innerHeight-bottom-56;
        if(rect.right>innerWidth-80 && rect.left<innerWidth-20 && rect.bottom>launcherTop && rect.top<innerHeight-bottom){
          bottom=Math.max(bottom,innerHeight-rect.top+16);
        }
      });
      const value=Math.ceil(bottom)+'px';
      this.style.setProperty('--rp-v2-chat-bottom',value);
      host.style.setProperty('--rp-v2-chat-bottom',value);
      // Inbox's translated nudge wrapper creates a fixed-position containing block.
      // Align its public activator part with our viewport probe without changing chat UI.
      const activator=host.shadowRoot?.querySelector('[part~="activator"]');
      if(activator){
        const rect=activator.getBoundingClientRect();
        if(rect.width && rect.height){
          const previousX=parseFloat(host.style.getPropertyValue('--rp-v2-chat-offset-x'))||0;
          const previousY=parseFloat(host.style.getPropertyValue('--rp-v2-chat-offset-y'))||0;
          host.style.setProperty('--rp-v2-chat-offset-x',(previousX+innerWidth-20-rect.right)+'px');
          host.style.setProperty('--rp-v2-chat-offset-y',(previousY+innerHeight-bottom-rect.bottom)+'px');
        }
      }
      const probe=this.querySelector('.rp-v2-launcher-probe').getBoundingClientRect();
      const overlap=element=>{
        if(!this.visible(element)) return false;
        const r=element.getBoundingClientRect();
        return probe.left<r.right+4 && probe.right>r.left-4 && probe.top<r.bottom+4 && probe.bottom>r.top-4;
      };
      const blockers='.drawer.active,header-drawer details[open],details-modal details[open],dialog[open],.cookies-banner.open,#shopify-pc__banner';
      const copy='.rp-v2-hero-copy,.rp-v2-story-heading,.rp-v2-active .rp-v2-story-copy,.cart__ctas,.cart__footer';
      const obstructed=[...document.querySelectorAll(blockers)].some(e=>this.visible(e)) || [...document.querySelectorAll(copy)].some(overlap);
      this.toggleAttribute('data-rp-v2-obstructed',obstructed);
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.resize?.disconnect();this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
      this.host?.style.removeProperty('--rp-v2-chat-bottom');
      this.host?.style.removeProperty('--rp-v2-chat-offset-x');
      this.host?.style.removeProperty('--rp-v2-chat-offset-y');
    }
  });
}
